"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrDesktopNavSubMenu = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const fdr_desktop_nav_link_1 = require("./fdr-desktop-nav-link");
const SubLinksListWrap = styled_components_1.default.div(({ theme, hide }) => (0, util_theme_sxc_1.sx2CssThemeFn)(Object.assign(Object.assign({}, theme.menu.subLinksListWrap), { display: hide ? 'none' : 'flex' })));
const SubLinksList = styled_components_1.default.ul(({ theme }) => (0, util_theme_sxc_1.sx2CssThemeFn)(theme.menu.subLinksList));
const FdrDesktopNavSubMenu = ({ hideSubMenu, items, internalLinkIconName, onClick, onLinkInteraction, }) => {
    return (react_1.default.createElement(SubLinksListWrap, { className: "sub-links-list", hide: hideSubMenu },
        react_1.default.createElement(SubLinksList, null, items.map((item, j) => {
            return (react_1.default.createElement(fdr_desktop_nav_link_1.FdrDesktopNavLink, { key: j, isSubMenu: true, item: item, internalLinkIconName: internalLinkIconName, onClick: () => {
                    onClick === null || onClick === void 0 ? void 0 : onClick(item.link, j);
                }, onLinkInteraction: onLinkInteraction }));
        }))));
};
exports.FdrDesktopNavSubMenu = FdrDesktopNavSubMenu;
//# sourceMappingURL=fdr-desktop-nav-sub-menu.js.map